// extracted by mini-css-extract-plugin
module.exports = {"resources":"Resources_resources__82V1S","intro":"Resources_intro__E9lUn","content":"Resources_content__2t+XJ","card":"Resources_card__w6U-a"};